module.exports = __webpack_public_path__ + "static/media/video3.891abb45.mp4";